import React from 'react';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import SearchIcon from '../../../../shared/images/magnifying-glass.svg';
import { ColorGray, ColorPrimary, ColorWhite } from '../../../../shared/GlobalStyles';

const BottomDiv = styled('div')`
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 4px;
`;

const CloseButton = styled('button')`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 12px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 12px;
  z-index: 100;
`;

const HeaderIconWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 50px;
`;

export const ListItem = styled('button')`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  line-height: 32px;
  margin: ${(props) => (props.centerHorizontally ? '0 auto 4px auto' : '0 0 4px 0')};
  padding: 8px;
  text-align: left;
  top: 0;
  width: 360px;
  z-index: 1;
  p {
    margin-bottom: 0;
    margin-left: ${(props) => props.itemMarginLeft || '0px'};
  }
  &:hover {
    background-color: #eeeeee;
    border-radius: 8px;
    font-weight: 500;
  }
  @media screen and (max-width: 440px) {
    width: 324px;
  }
`;

const ModalHeaderDiv = styled('div')`
  align-items: center;
  background: ${ColorWhite};
  border-bottom: 1px solid ${ColorGray};
  color: ${ColorPrimary};
  display: flex;
  flex-direction: column;
  font-weight: 500;
  height: 75px;
  justify-content: flex-end;
  margin: 20px 0 0 0;
  padding: 10px 30px;
  width: 100%;
  z-index: 1;
`;

export const ModalWrapper = styled('div')`
  border-radius: 10px;
  display: flex;
  max-width: 400px;
  width: 100%;
  .ReactModal__Content {
    border-radius: 5px;
  }
  @media screen and (max-width: 440px) {
    max-width: 360px;
  }
`;

export const NavigationWrapper = styled('div')`
  align-items: center;
  background: ${ColorWhite};
  border: none;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  color: ${ColorPrimary};
  display: flex;
  font-size: 12px;
  font-weight: 500;
  height: 25px;
  justify-content: end;
  margin-top: 10px;
  padding: 8px;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const NoDataDiv = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;
`;

const NoDataText = styled('p')`
  color: ${ColorPrimary};
  font-size: 12px;
  margin-top: 10px;
`;

export const PrimaryWrapper = styled('div')`
  background: ${ColorWhite};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  font-family: 'Nunito Sans';
  justify-content: center;
  padding: ${(props) => props.padding || '0px 0px 10px'};
  width: 900px;
  .text-area {
    background: ${ColorWhite};
    border: none;
    box-shadow: none;
    font-size: 28px;
    height: 200px;
    outline: none;
    padding: 20px 20px 20px;
    resize: none;
    .rc-textarea {
      height: 100%;
      padding: 0px;
    }
  }
`;

const SearchDiv = styled('div')`
  align-items: center;
  background-color: #f5f5f5;
  border: none;
  border-radius: 10px;
  color: #a3a3a3;
  display: flex;
  font-weight: 500;
  height: 48px;
  margin: 10px auto 0 auto;
  padding: 8px 12px;
  width: 90%;
`;

const SearchIconWrapper = styled('div')`
  align-items: center;
  background-image: url(${SearchIcon});
  background-position-x: 50%;
  background-repeat: no-repeat;
  background-size: 16px;
  display: flex;
  height: 16px;
  justify-content: center;
  width: 10%;
`;

const SearchInput = styled('input')`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${(props) => (props.value ? ColorPrimary : '#a3a3a3')};
  display: flex;
  justify-content: start;
  width: 90%;
`;

export const IconContainer = styled('div')`
  align-items: center;
  display: flex;
  height: ${(props) => props.size || '60px'};
  justify-content: center;
  width: ${(props) => props.size || '60px'};
  ${(props) => props.marginRight && `margin-right: ${props.marginRight};`}
`;

export const CloseButtonContainer = ({ onRequestClose, iconColor }) => (
  <CloseButton aria-label='Close modal' onClick={onRequestClose}>
    <IcomoonReact iconSet={iconSet} size={12} icon='remove' color={iconColor} aria-hidden='true' />
  </CloseButton>
);

CloseButtonContainer.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  iconColor: PropTypes.string,
};

CloseButtonContainer.defaultProps = {
  iconColor: ColorPrimary,
};

export const PickerModalNoData = ({ message }) => (
  <NoDataDiv>
    <IconContainer size='60px'>
      <IcomoonReact
        iconSet={iconSet}
        size={60}
        icon='warning'
        color={ColorPrimary}
      />
    </IconContainer>
    <NoDataText>{message}</NoDataText>
  </NoDataDiv>
);

PickerModalNoData.propTypes = {
  message: PropTypes.string.isRequired,
};

export const PickerModalSearch = ({
  placeholder,
  value,
  onChange,
  ariaLabel,
}) => (
  <SearchDiv>
    <SearchIconWrapper />
    <SearchInput
      type='text'
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  </SearchDiv>
);

PickerModalSearch.propTypes = {
  ariaLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

PickerModalSearch.defaultProps = {
  ariaLabel: undefined,
};

const PickerModal = ({
  children,
  onRequestClose,
  headerText,
  headerIcon = '',
}) => (
  <ModalWrapper>
    <PrimaryWrapper>
      <CloseButtonContainer onRequestClose={onRequestClose} />
      <ModalHeaderDiv>
        {headerIcon && (
          <HeaderIconWrapper>
            <IcomoonReact
              iconSet={iconSet}
              size={32}
              icon={headerIcon}
              color={ColorPrimary}
            />
          </HeaderIconWrapper>
        )}
        <h4>{headerText}</h4>
      </ModalHeaderDiv>
      {children}
      <BottomDiv />
    </PrimaryWrapper>
  </ModalWrapper>
);

PickerModal.propTypes = {
  children: PropTypes.node.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  headerIcon: PropTypes.string,
};

PickerModal.defaultProps = {
  headerIcon: '',
};

export default PickerModal;
